import React from 'react';
import './MusicSection.css';

const MusicSection = ({ title, type, tracks, videoEmbed, hasNewsletter }) => {
    return (
        <section className={`music-section ${type}`}>
            <h2>{title}</h2>

            <div className="music-content">
                {hasNewsletter && (
                    <div className="newsletter-block">
                        <h3>Subscribe to Newsletter</h3>
                        <form
                            className="newsletter-form"
                            action="https://formspree.io/f/xjgrbgko"
                            method="POST"
                        >
                            <input type="email" name="email" placeholder="Your email address" required />
                            <button type="submit">SUBSCRIBE</button>
                        </form>
                    </div>
                )}

                <div className="tracks-container">
                    {tracks.map(track => {
                        const embedType = track.type || 'track';
                        const embedHeight = track.height || '152';
                        return (
                            <div key={track.id} className="track-item">
                                <iframe
                                    src={`https://open.spotify.com/embed/${embedType}/${track.spotifyId}?utm_source=generator&theme=0`}
                                    width="100%"
                                    height={embedHeight}
                                    frameBorder="0"
                                    allowfullscreen=""
                                    allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                                    loading="lazy"
                                    title={track.title}
                                    style={{ borderRadius: '12px' }}
                                ></iframe>
                            </div>
                        );
                    })}
                </div>

                {videoEmbed && (
                    <div className="video-container">
                        <iframe
                            width="560"
                            height="315"
                            src={videoEmbed}
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        ></iframe>
                    </div>
                )}
            </div>
        </section>
    );
};

export default MusicSection;
